import { ShoppingCart } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconCart(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <ShoppingCart />
    </IconWrapper>
  );
}
